module.exports = __webpack_public_path__ + "static/MarqueeHomeLogo-1026b1fa63349d5c515289713ed8d4ab.png";